import React from 'react';

import Output from './innerComp/Output';

const Display = () => {
    
    
        return (
        <>
            <div className='Display'>
              <Output/> 
            </div>
        </>
    );
}

export default Display;
